import React from "react";
import { Button, dialog, Modal } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";
import EmployeeDetails from "./components/OnBoardDetails";
import excludeFields from "./components/ExcludeField";
import DialogCreate from "./components/DialogCreate";
import TableUser from "../../../components/TableUser";
import DialogDelete from "./components/DialogDelete";
import DialogReset from "./components/DialogReset";
import OnBoardListPresenter from "./OnBoardingListPresenter";
import Table from "../../../components/Table";
import OnBoardDetails from "./components/OnBoardDetails";
import DialogSuccess from "./components/DialogSuccess";

class OnBoardingListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new OnBoardListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      showDetails: false,
      empDetails: {},
      showModal: false,
      showFilters: false,
      formData: {
        id: "",
        name: "",
        description: "",
        recruiter: {},
        assignedDate: "",
      },
    };
  }

  getCollectionName() {
    return "on_boarding";
  }

  getToken() {
    return this.getParams().token;
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  handleSubmit = () => {
    this.presenter.handleSubmit(this.state.formData);
  };

  clickData(object, index) {
    this.setState({ showFilters: true, showDetails: true, empDetails: object });
  }

  hideFilter() {
    this.setState({ showDetails: false });
  }

  onClickEdit() {
    const { empDetails } = this.state;
    this.presenter.onClickEdit(empDetails);
  }

  handleDelete() {
    const { empDetails } = this.state;
    this.presenter.onClickDelete(empDetails);
  }

  onSubmitPassword() {
    this.presenter.onSubmitPassword(this.state.password);
  }

  onChangeDate(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeDate(value, schema);
  }

  onChange(value, field) {
    this.setState((prevState) => ({
      password: {
        ...prevState.password,
        [field]: value,
      },
    }));
  }

  onClickAdd(object) {
    const schema = this.getSchemas();
    const schemas = this.getSchema(this.getCollectionName());
    const formData = this.state.formData;

    dialog.fire({
      html: (
        <DialogCreate
          schema={schema}
          schemas={schemas}
          objects={object}
          onChangeData={this.onChangeObject.bind(this)}
          handleSubmit={this.handleSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onClickDelete() {
    const { empDetails } = this.state;
    dialog.fire({
      html: (
        <>
          <DialogDelete
            empDetails={empDetails}
            clickDelete={this.handleDelete.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  onclickReset() {
    dialog.fire({
      html: (
        <>
          <DialogReset
            onChangeField={this.onChange.bind(this)}
            clickSubmit={this.onSubmitPassword.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }
  hideFilter() {
    this.setState({ showFilters: false });
  }
  showFilter() {
    this.setState({ showFilters: true });
  }

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  getInitialFormData() {
    this.setState({
      formData: {
        formData: {
          id: "",
          name: "",
          description: "",
          recruiter: {},
          assignedDate: "",
        },
      },
    });
  }

  closeModal = () => {
    this.setState({ showModal: false });
    setTimeout(() => {
      this.forceUpdate();
    }, 100);
  };

  clickDataApplicant(object) {
    this.navigateTo(`/recruiter/onboard-list/${object?.id}`);
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      read: ["*", user.id],
      write: ["*", user.id],
    };
  }
  successModal(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }
  closeDialog() {
    dialog.close();
  }

  handleUpdate(formData) {
    this.presenter.handleUpdate(formData);
  }
  clickEdit() {
    const { empDetails } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    dialog.fire({
      html: (
        <DialogCreate
          schema={schema}
          schemas={schemas}
          objects={empDetails}
          onChangeData={(value, field) =>
            this.setState((prevState) => ({
              formData: { ...prevState.formData, [field]: value },
            }))
          }
          handleSubmit={this.handleUpdate.bind(this)}
          handleClose={this.closeDialog.bind(this)}
        />
      ),
      footer: false,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const schemass = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    const {
      objects,
      selected,
      count,
      progress,
      empDetails,
      showDetails,
      showFilters,
      formData,
      showModal,
    } = this.state;

    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />

        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">
                  {schema.label || this.getCollectionName()}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>

              <div className="d-flex flex-column">
                <div className="d-flex justify-content-start">
                  <p
                    className="align-self-end m-0 cursor-pointer fw-bold"
                    style={{ color: `#D18237` }}
                    onClick={this.showFilter.bind(this)}
                  >
                    <i class="bi bi-filter"></i>Filter
                  </p>
                </div>
                <div className="d-flex gap-2">
                  <div className="d-flex flex-column">
                    {showFilters ? (
                      <div
                        className="d-flex flex-column me-2 w-100"
                        style={{
                          width: "50%",
                          position: "sticky",
                          top: 0,
                          alignSelf: "flex-start",
                          zIndex: 1,
                        }}
                      >
                        <div className="card mt-1 p-3">
                          <h6 className="fw-bold" style={{ color: "black" }}>
                            <i
                              class="bi bi-arrow-left me-2 cursor-pointer"
                              onClick={this.hideFilter.bind(this)}
                            ></i>
                            Filter
                          </h6>

                          {/* <label className="mt-2">Date</label>
                    <InputFactory
                      type="date"
                      onChange={this.onChangeDate.bind(this)}
                      placeholder="Enter Position"
                    /> */}
                          <label className="mt-2">Date</label>
                          <InputFactory
                            type="date"
                            placeholder="Enter Date"
                            onChange={this.onChangeDate.bind(this)}
                          />
                        </div>
                        {showDetails ? (
                          <OnBoardDetails
                            empDetails={empDetails}
                            clickEdit={this.clickEdit.bind(this)}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className=" w-100">
                    {user.roles[0]?.id === "HR" ? (
                      <Table
                        fields={schema.fields}
                        onClick={this.clickData.bind(this)}
                        objects={objects}
                        // selectable
                        // collapsable
                        excludeFields={Object.keys(schema.fields).reduce(
                          (acc, key) => {
                            const options = schema.fields[key];
                            if (options.read === false) {
                              acc.push(key);
                            }
                            switch (options._type || options.type) {
                              case "Relation":
                              case "Array":
                              case "Object":
                              case "File":
                                acc.push(key);
                                break;
                              default:
                            }
                            return acc;
                          },
                          excludeFields
                        )}
                        selected={selected}
                        onSelect={this.onSelect.bind(this)}
                        onSelectAll={this.onSelectAll.bind(this)}
                        progress={progress}
                        onClickItem={this.onClickItem.bind(this)}
                        onSort={this.onClickSort.bind(this)}
                        className="mt-1"
                      />
                    ) : (
                      <Table
                        fields={schema.fields}
                        onClick={this.clickDataApplicant.bind(this)}
                        objects={objects}
                        // selectable
                        // collapsable
                        excludeFields={Object.keys(schema.fields).reduce(
                          (acc, key) => {
                            const options = schema.fields[key];
                            if (options.read === false) {
                              acc.push(key);
                            }
                            switch (options._type || options.type) {
                              case "Relation":
                              case "Array":
                              case "Object":
                              case "File":
                                acc.push(key);
                                break;
                              default:
                            }
                            return acc;
                          },
                          excludeFields
                        )}
                        selected={selected}
                        onSelect={this.onSelect.bind(this)}
                        onSelectAll={this.onSelectAll.bind(this)}
                        progress={progress}
                        onClickItem={this.onClickItem.bind(this)}
                        onSort={this.onClickSort.bind(this)}
                        className="mt-1"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
        {user.roles[0]?.id === "HR" && (
          <div className="position-fixed bottom-0 end-0 m-4">
            <Button
              className="btn shadow-sm text-white"
              // onClick={this.onClickAdd.bind(this)}
              onClick={this.toggleModal}
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "25px",
                backgroundColor: "#e09552",
              }}
            >
              <i className="bi bi-plus-lg" />
            </Button>
          </div>
        )}

        <Modal isOpen={showModal} closable size="md">
          <Modal.Body>
            <DialogCreate
              schema={schema}
              schemas={schemas}
              objects={formData}
              onChangeData={(value, field) =>
                this.setState((prevState) => ({
                  formData: { ...prevState.formData, [field]: value },
                }))
              }
              handleSubmit={this.handleSubmit}
              handleClose={this.closeModal.bind(this)}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default withRouter(OnBoardingListPage);
